import { Layout } from '@components/common'
import { PurchasedItem, TopBackBar } from '@components/account'
import useCustomerKits from '@lib/hooks/useCustomerKits'
import useProductsWithIds from '@lib/hooks/useProductsWithIds'
import useCustomer from '@framework/customer/use-customer'
import { LoadingDots } from '@components/ui'
import { useRouter } from 'next/router'
import React, { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import AddKit from '@components/account/AddKit/AddKit'

export default function Kits() {
  const t = useTranslations('Activation')
  const { kits, isLoading } = useCustomerKits()
  const { data: customer, isLoading: customerLoading } = useCustomer()
  const { products } = useProductsWithIds(kits?.map((kit: any) => kit?.shopify_product_id))
  const router = useRouter()
  const productImages = useMemo(() => {
    if (kits && products) {
      return kits.reduce((images: any, kit: any) => {
        const id = kit.shopify_product_id
        if (products.length > 0 && products[0] !== null) {
          const kitProduct = products.find((product: any) => product.id.includes(id))
          if (kitProduct && kitProduct?.featuredImage) {
            images[id] = kitProduct?.featuredImage?.edges[0]?.node?.originalSrc
          }
        }
        return images
      }, {})
    }
  }, [kits, products])

  if (!customerLoading && !customer) {
    router.replace({
      pathname: '/auth/login',
      query: { redirect_to: router.asPath }
    })
  }

  return (
    <>
      <div className='bg-neutral200 py-16 min-h-screen'>
        <TopBackBar link='/orders' text={t('orderHistory')} />
        <div className='px-6 md:px-12'>
          <h4 className='mt-12 font-medium text-heading03 text-neutral900 mb-6'>
            {t('activatableKits')}
          </h4>
          {isLoading ? (
            <>
              <LoadingDots />
            </>
          ) : (
            <div className={'grid grid-cols-1 md:grid-cols-2 gap-10'}>
              <ul className='grid grid-cols-1 gap-10'>
                {isLoading && <LoadingDots />}
                {kits?.length === 0 && !isLoading && <p className='text-left text-title-1'>{t('noKitsFound')}</p>}
                {kits?.length  > 0 && !isLoading && kits?.map(
                  (kit: any) => (kit.lab_order_id == null &&
                    <PurchasedItem
                      key={kit.id}
                      line1={`#${kit.shopify_order_name} - ${kit.shopify_line_item?.name}`}
                      line2={`${t('orderedOn')} <strong>${new Date(kit.createdAt).toLocaleDateString()}</strong>`}
                      buttonCta={t('activateTest')}
                      buttonHandler={() => router.push({ pathname: `/activateKits/${kit.id}`, query: router.query })}
                      image={productImages ? productImages[kit.shopify_product_id] : null}
                      hasButton={true} />
                  )
                )}
              </ul>
              <div>
                <div className={'float-right'}>
                  <AddKit />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

Kits.Layout = Layout
